// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Azure Rest Core Client library for JavaScript
 * @packageDocumentation
 */

export { createRestError } from "./restError";
export * from "./getClient";
export * from "./common";
